import { render, staticRenderFns } from "./evaluate.vue?vue&type=template&id=ad3c15c4&scoped=true"
import script from "./evaluate.vue?vue&type=script&lang=js"
export * from "./evaluate.vue?vue&type=script&lang=js"
import style0 from "./evaluate.vue?vue&type=style&index=0&id=ad3c15c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3c15c4",
  null
  
)

export default component.exports